import React from "react";
import SparkleIcon from "../../../assets/images/Dietplan-updated/sparkle.svg";
import GoldBadgeIcon from "../../../assets/images/Dietplan-updated/Group 1116601110.svg";
import GoldPlanIcons from "../../../assets/images/Dietplan-updated/Group 1116601171.png";
import { PlanName } from "../../../constants";
import CalorieTrackSection from "./CalorieTrackSection";
import ReportInsightsSection from "./ReportInsightsSection";
import UnlockFeaturesSection from "./UnlockFeaturesSection";
import WeightJourneySection from "./WeightJourneySection";
import CalorieTrackAndroidSection from "./CalorieTrackAndroidSection";
import { openTermsAndConditionWeb } from "../../../helper/mobile";

const GOLD_FEATURES = [
  {
    title: (
      <>
        Powered by <span className="gold-plan-highlight">Dr Trust Intelligence</span>
      </>
    ),
    description: "Advanced intelligence driving personalized health insights.",
  },
  {
    title: "AI-Based Diet Plans",
    description: "Personalized diet plans generated using smart scale data and health goals.",
  },
  {
    title: "Automatic Trend Detection",
    description: "Identifies patterns and trends in health and nutrition data.",
  },
  {
    title: "Personalized Health Analysis",
    description: "Delivers tailored insights to keep users on track.",
  },
  {
    title: "Weekly Goal Analysis",
    description: "Reviews weekly progress against set goals.",
  },
  {
    title: "Smart Scale Integration",
    description: "Syncs body metrics like weight, BMI, and body fat.",
  },
  {
    title: "Dietary & Region-Specific Preferences",
    description: "Customizes plans based on dietary choices and regional food habits.",
  },
  {
    title: "Daily Calorie Tracker",
    description: "Tracks daily calorie intake.",
  },
  {
    title: "Water Tracker",
    description: "Monitors daily water consumption.",
  },
  {
    title: "PDF Health Reports",
    description: "Generates downloadable health and progress reports.",
  },
  {
    title: "Health Guardian (BP & Sugar)",
    description: "Tracks blood pressure and blood sugar readings.",
  },
];

const GoldPlanCard = ({ selectedPlanType }) => {
  const isSilverPlan =
    selectedPlanType === PlanName.ELITE_PLAN ||
    selectedPlanType === PlanName.YEARLY_ELITE_PLAN;

  return (
    <section className="gold-plan-card-section">
      <div className="gold-plan-stack">
        {!isSilverPlan && (
          <div className="gold-plan-card-wrap">
            <div className="gold-plan-card">
              <div className="gold-plan-card-header">
                <h2 className="gold-plan-card-title">
                  <span className="gold-plan-title-text gold-plan-gradient-text">
                    Generated AI Diet Plan
                  </span>
                  <img src={GoldBadgeIcon} alt="" className="gold-plan-sparkle" />
                </h2>
                <div className="gold-plan-icon-row">
                  <img src={GoldPlanIcons} alt="" className="gold-plan-icons-img" loading="lazy" />
                </div>
              </div>

              <ul className="gold-plan-feature-list">
                {GOLD_FEATURES.map((item, index) => (
                  <li key={index} className="gold-plan-feature-item">
                    <span className="gold-plan-check" />
                    <div>
                      <div className="gold-plan-feature-title">{item.title}</div>
                      <p className="gold-plan-feature-desc">{item.description}</p>
                    </div>
                  </li>
                ))}
              </ul>

              <div className="gold-plan-footer">
                <span className="gold-plan-plus" />
                <span className="gold-plan-footer-text">Everything in Pro Lite Plan</span>
              </div>
            </div>
          </div>
        )}

        <div className="gold-plan-calorie-track">
          {isSilverPlan ? <CalorieTrackAndroidSection /> : <CalorieTrackSection />}
        </div>
        <div className="gold-plan-report-insights">
          <ReportInsightsSection />
        </div>
        <div className="gold-plan-all-feature">
          <UnlockFeaturesSection />
        </div>
        <div className="gold-plan-weight-img">
          <WeightJourneySection />
        </div>
        <div className="gold-plan-disclaimer">
          <p className="gold-plan-disclaimer-text">
            *we will be using your health data to create and curate personalised ai recommendation for you
          </p>
          <a
            className="gold-plan-tnc-text"
            href="https://terms.drtrust360.com/"
            target="_blank"
            rel="noreferrer"
            onClick={(e) => {
              e.preventDefault();
              openTermsAndConditionWeb();
            }}
          >
            Terms &amp; Conditions
          </a>
        </div>
      </div>
    </section>
  );
};

export default GoldPlanCard;
